import { Skeleton, HStack, Text, Flex } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Keyword } from '@/components/ui/features/lecture/LectureAbstract/components/LectureKeywords.elements';
import { queryKeywordsByLectureId } from '@/fetchers/keywords';
import { useResources } from '@/lib/datx-jsonapi-react';
import { ThinLecture } from '@/resources/ThinLecture';

interface ILectureKeywordsProps {
  data: ThinLecture;
}

export const LectureKeywords: FC<ILectureKeywordsProps> = ({ data: lecture }) => {
  const { t } = useTranslation();
  const { data: keywords, error } = useResources(queryKeywordsByLectureId(lecture.id));

  if (error) {
    throw error;
  }

  if (!keywords) {
    return <LectureKeywordsFallback />;
  }

  if (keywords.length === 0) {
    return null;
  }

  return (
    <Flex flexWrap="wrap">
      <Text m={0} pr={2}>
        {t('lecture.keywords.title')}:
      </Text>
      {keywords.map(({ name }) => (
        <Keyword key={name}>{name}</Keyword>
      ))}
    </Flex>
  );
};

const LectureKeywordsFallback: FC = () => {
  return (
    <HStack>
      <Skeleton height="24px" width="10%" />
      <Skeleton height="24px" width="80%" />
    </HStack>
  );
};
